// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"64705fdd","651":"334b02c4","728":"9e943212","847":"53367fb7","933":"22362614","983":"9590ea96","988":"f2f677c4"}[chunkId] + ".chunk.js";
};